var _classCallCheck = require("/work/Jointer/atom_auction/master/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/work/Jointer/atom_auction/master/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/work/Jointer/atom_auction/master/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var ProviderSubprovider = require('./json-rpc-engine-middleware');

var createBlockCacheMiddleware = require('eth-json-rpc-middleware/block-cache');

var BlockCacheSubprovider = /*#__PURE__*/function (_ProviderSubprovider) {
  "use strict";

  _inherits(BlockCacheSubprovider, _ProviderSubprovider);

  var _super = _createSuper(BlockCacheSubprovider);

  function BlockCacheSubprovider(opts) {
    _classCallCheck(this, BlockCacheSubprovider);

    return _super.call(this, function (_ref) {
      var blockTracker = _ref.blockTracker;
      return createBlockCacheMiddleware(Object.assign({
        blockTracker: blockTracker
      }, opts));
    });
  }

  return BlockCacheSubprovider;
}(ProviderSubprovider);

module.exports = BlockCacheSubprovider;